import { ColumnDef } from "@tanstack/react-table"
import { InvoicesHistoryData } from "@/types"
import { DataTableColumnHeader } from "../../shared/table/TableColumnHeader"
import { InvoiceTableRowActions } from "./InvoiceRowActions"
import { currenciesMap } from "@/components/invoiceArea/currencies"
import { formatPrice } from "@/utils"

export const invoicesColumns: ColumnDef<InvoicesHistoryData>[] = [
    {
        id: "select",
        header: ({ table }) => (
            <label style={{ display: "flex", width: "100%", justifyContent: "center", cursor: "pointer", boxShadow: "none" }}>
                <input style={{ cursor: "pointer" }}
                    checked={table.getIsAllPageRowsSelected()}
                    aria-label="Select all"
                    type="checkbox"
                    onChange={() => {
                        if (table.getIsAllPageRowsSelected()) {
                            table.toggleAllPageRowsSelected(false);
                        } else {
                            table.toggleAllPageRowsSelected(true);
                        }
                    }}
                />
            </label>
        ),
        cell: ({ row }) => (
            <label style={{ display: "flex", width: "100%", justifyContent: "center", cursor: "pointer", boxShadow: "none" }}>
                <input style={{ cursor: "pointer" }}
                    checked={row.getIsSelected()}
                    onChange={(event) => row.toggleSelected(event.target.checked)}
                    onClick={(e) => e.stopPropagation()}
                    aria-label="Select row"
                    type="checkbox"

                />
            </label>
        ),
        size: 4,
        minSize: 4,
        enableSorting: false,
        enableHiding: false,
    },
    {
        accessorKey: "invoiceNumber",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Number" table={table} />
        ),
        cell: ({ row }) => <div>{row.getValue("invoiceNumber")}</div>,
        size: 12.5,
        minSize: 12.5,
        enableSorting: false,
        enableHiding: false,
    },
    {
        accessorKey: "invoiceName",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Title" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div className="table-cell" style={{ maxWidth: "200px", minWidth: "100px" }}>
                    <span
                        className="cell__text"
                        style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "block",
                            width: "100%",
                        }}
                    >
                        {row.getValue("invoiceName")}
                    </span>
                </div>
            )
        },
        size: 20,
        minSize: 20,
        enableSorting: true
    },
    {
        id: "status",
        accessorKey: "status",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Status" table={table} />
        ),
        cell: ({ row }) => {
            const status = row.getValue("status") as string;
            return (
                <div className={`${status} status`}>
                    <span>{status}</span>
                </div>
            )
        },
        filterFn: (row, id, value) => {
            return value.includes(row.getValue(id))
        },
        size: 18,
        minSize: 18,
        enableSorting: false
    },
    {
        accessorKey: "billTo",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Customer" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div>
                    {row.getValue("billTo")}
                </div>
            )
        },
        filterFn: (row, id, value) => {
            return value.includes(row.getValue(id))
        },
        size: 15.5,
        minSize: 15.5,
        enableSorting: true
    },
    {
        accessorKey: "dateIssued",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Issued" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div>
                    {row.getValue("dateIssued")}
                </div>
            )
        },
        size: 12.5,
        minSize: 12.5,
        sortingFn: (a, b) => a.original.lastModified - b.original.lastModified
    },
    {
        accessorKey: "totalToPay",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Amount" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div>
                    {currenciesMap.get(row.original.currency)?.symbol}
                    {formatPrice(row.getValue("totalToPay"))}
                </div>
            )
        },
        size: 15.5,
        minSize: 15.5,
        enableSorting: true
    },
    {
        id: "actions",
        cell: ({ row, table }) => <InvoiceTableRowActions row={row} table={table} />,
        size: 4,
        minSize: 4,
    },
];

